import { render, staticRenderFns } from "./CouponGrantLogList.vue?vue&type=template&id=a6c3f82c&lang=pug&"
import script from "./CouponGrantLogList.vue?vue&type=script&lang=ts&"
export * from "./CouponGrantLogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports